import { render } from "./UploadTag.vue?vue&type=template&id=6624938f&scoped=true"
import script from "./UploadTag.vue?vue&type=script&lang=js"
export * from "./UploadTag.vue?vue&type=script&lang=js"

import "./UploadTag.vue?vue&type=style&index=0&id=6624938f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6624938f"]])

export default __exports__